import { Helmet } from 'react-helmet-async';
import { filter, set } from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
// @mui
import dayjs from 'dayjs';
import {
  Card,
  Table,
  Stack,
  Paper,
  Avatar,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  Box,
} from '@mui/material';

import '../css/style.css';
import { CSVLink } from 'react-csv';
import { GetTransaction, getSingleTransaction } from '../redux/actions/Transaction';
import { getSingleTicket, getTicket } from '../redux/actions/Ticketaction';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'userId', label: 'userId', alignRight: false },
  { id: 'EmployerId', label: 'EmployerId', alignRight: false },
  { id: 'EmployeeEmailId', label: 'EmployeeEmailId', alignRight: false },
  { id: 'loanId', label: 'loanId', alignRight: false },
  { id: 'totalAmount', label: 'totalAmount', alignRight: false },
  { id: 'transactionFee', label: 'transactionFee', alignRight: false },
  { id: 'nbfctranscactionId', label: 'nbfctranscactionId', alignRight: false },
  { id: 'withdrawalAmount', label: 'withdrawalAmount', alignRight: false },
  { id: '' },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  console.log('order', order, orderBy);
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  console.log(' stabilizedThis', stabilizedThis);

  return stabilizedThis?.map((el) => el[0]);
}

export default function Transactionpage() {
  const dispatch = useDispatch();

  const { userId } = useParams();

  const gettransaction = useSelector((state) => state?.Transaction?.getTrasaction?.data);

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [timeoutVal, setTimeoutVal] = useState(null);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [sort, setSort] = useState(false);
  const [fromdate, setFromdate] = useState(dayjs().subtract(1, 'year'));
  const [todate, setTodate] = useState(dayjs());
  const [status, setStatus] = useState('open');
  const [transaction, setTrasaction] = useState(gettransaction);

  const fromdata = dayjs(fromdate).startOf('day').format();
  const todata = dayjs(todate).endOf('day').format();

  const handleFilter = () => {
    dispatch(GetTransaction(filterName, fromdata, todata));
    setSort(false);
  };

  useEffect(() => {
    if (gettransaction && gettransaction?.length > 0)
      setTrasaction(
        gettransaction?.map((item) => {
          console.log('item', item);
          return {
            nbfctranscactionId: item?.nbfctranscactionId,
            loanId: item?.loanId,
            totalAmount: item?.totalAmount,
            transactionFee: item?.transactionFee,
            withdrawalAmount: item?.withdrawalAmount,
            userId: item?.userId,
            EmployeeEmailId: item?.EmployeeEmailId,
            EmployerId: item?.EmployerId,
          };
        })
      );
  }, [gettransaction]);

  const visibleRows = useMemo(() => {
    return applySortFilter(transaction, getComparator(order, orderBy));
  }, [transaction, order, orderBy]);

  console.log('visibleRows', visibleRows);

  useEffect(() => {
    if (userId) {
      dispatch(getSingleTransaction(userId, filterName, fromdata, todata));
    } else {
      dispatch(GetTransaction(filterName, fromdata, todata));
    }
  }, [filterName]);
  useEffect(() => {
    if (timeoutVal) {
      clearTimeout(timeoutVal);
      setTimeoutVal(null);
    }
    const timeout = setTimeout(() => {
      if (userId) {
        dispatch(getSingleTransaction(userId, filterName, fromdata, todata));
      } else {
        dispatch(GetTransaction(filterName, fromdata, todata));
      }
    }, 2000);
    setTimeoutVal(timeout);
  }, [filterName]);

  // for table data

  useEffect(() => {
    setTrasaction(gettransaction);
  }, [gettransaction]);

  // for table
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
    setPage(0);
  };

  const filteredUsers = applySortFilter(gettransaction, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers?.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Transaction | Minimal UI </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography sx={{ color: 'black' }} variant="h4" gutterBottom>
            Transaction
          </Typography>
          <Box sx={{ display: 'flex', gap: '10px' }}>
            {/* <Button onClick={handleOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
              Upload static Employee
            </Button> */}
            <Button variant="contained">
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={transaction !== undefined ? transaction : []}
                filename="tickets.csv"
                target=""
              >
                Download CSV
              </CSVLink>
            </Button>
          </Box>
        </Stack>

        {/*  */}
        <Card>
          <UserListToolbar
            name="Transaction"
            filterName={filterName}
            onFilterName={handleFilterByName}
            setFromdate={setFromdate}
            setTodate={setTodate}
            handleFilter={handleFilter}
            sort={sort}
            setSort={setSort}
            status={status}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, minHeight: 300 }}>
              <Table sx={{ px: '10px', position: 'relative' }}>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={gettransaction?.length}
                  onRequestSort={handleRequestSort}
                  //
                />
                <TableBody>
                  {visibleRows?.map((row, index) => {
                    const {
                      userId,
                      EmployerId,
                      EmployeeEmailId,
                      loanId,
                      totalAmount,
                      transactionFee,
                      nbfctranscactionId,
                      withdrawalAmount,
                    } = row;

                    return (
                      <TableRow hover key={index} tabIndex={-1} role="checkbox">
                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {userId}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {EmployerId}
                            </Typography>
                          </Stack>
                        </TableCell>
                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {EmployeeEmailId}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2" noWrap>
                              {loanId}
                            </Typography>
                          </Stack>
                        </TableCell>

                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px', maxWidth: '200px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2">{totalAmount}</Typography>
                          </Stack>
                        </TableCell>

                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px', maxWidth: '200px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2">{transactionFee}</Typography>
                          </Stack>
                        </TableCell>

                        <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px', maxWidth: '200px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2">{nbfctranscactionId}</Typography>
                          </Stack>
                        </TableCell>

                        {/* <TableCell
                          sx={{ cursor: 'pointer', paddingLeft: '10px', maxWidth: '200px' }}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Stack direction="row" alignItems="center" spacing={2}>
                            <Typography variant="subtitle2">{withdrawalAmount}</Typography>
                          </Stack>
                        </TableCell> */}

                        <TableCell sx={{ cursor: 'pointer' }} align="right">
                          <IconButton size="large" color="inherit">
                            <Iconify icon={'eva:more-vertical-fill'} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 150]}
            component="div"
            count={transaction?.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
    </>
  );
}
